/**
 * Response Soft practice catalog (Soft≠Live).
 * One Soft ID family for Queue ↔ Case ↔ Assign ↔ People ↔ Cell.
 * Soft never POSTs Live. Soft does NOT sync Map AI or Cameras Soft catalogs.
 */
export const SOFT_RESPONSE_STAMP = "soft_demo";

/** Soft people — Assign candidates + People roster share these usernames. */
export const SOFT_PEOPLE = [
  { user: "chen.wei", name: "Chen Wei", role: "responder", site: "North Gate", phone: "+60 12-337 4021", phoneRegion: "MY", phoneSay: "+60 12-337 4021 · MY", crew: "NightWatch", status: "active", on: true, ver: "soft-1", granted: "Soft · preview", ret: 30, tier: "fine", hasFix: true, positionSay: "3.13900, 101.68700", assignmentSay: "Not on a Live job", soft_demo: true },
  { user: "maya.ortiz", name: "Maya Ortiz", role: "responder", site: "Plant B", phone: "+60 16-882 1104", phoneRegion: "MY", phoneSay: "+60 16-882 1104 · MY", crew: "NightWatch", status: "active", on: true, ver: "soft-1", granted: "Soft · preview", ret: 30, tier: "fine", hasFix: true, positionSay: "3.14100, 101.69100", assignmentSay: "Not on a Live job", soft_demo: true },
  { user: "omar.hassan", name: "Omar Hassan", role: "responder", site: "East Dock", phone: "+60 19-554 2208", phoneRegion: "MY", phoneSay: "+60 19-554 2208 · MY", crew: "DockAlpha", status: "active", on: true, ver: "soft-1", granted: "Soft · preview", ret: 14, tier: "coarse", hasFix: true, positionSay: "3.13700, 101.69400", assignmentSay: "soft-demo-p2-dock", soft_demo: true },
  { user: "aisha.rahman", name: "Aisha Rahman", role: "lead", site: "Main Lobby", phone: "+60 11-2233 8890", phoneRegion: "MY", phoneSay: "+60 11-2233 8890 · MY", crew: "LobbyLead", status: "active", on: true, ver: "soft-1", granted: "Soft · preview", ret: 30, tier: "fine", hasFix: true, positionSay: "3.14000, 101.68600", assignmentSay: "soft-demo-p3-lobby", soft_demo: true },
  { user: "luis.park", name: "Luis Park", role: "responder", site: "Stair C", phone: "+60 13-700 4412", phoneRegion: "MY", phoneSay: "+60 13-700 4412 · MY", crew: "", status: "active", on: false, ver: "soft-1", granted: "Soft · preview", ret: 7, tier: "coarse", hasFix: false, positionSay: "No live fix", assignmentSay: "Not on a Live job", soft_demo: true },
  { user: "nina.cho", name: "Nina Cho", role: "observer", site: "West Yard", phone: "", phoneRegion: "", phoneSay: "No phone on file", crew: "", status: "none", on: false, ver: "—", granted: "—", ret: "—", tier: "—", hasFix: false, positionSay: "No live fix", assignmentSay: "Not on a Live job", soft_demo: true },
];

/** Soft devices with fix — Assign step 1 / People drop dock (>10 for scroll practice). */
export const SOFT_DEVICES = [
  { device_id: "gate-north-04", id: "gate-north-04", label: "North Gate · CAM-04", display_label: "North Gate · CAM-04", lat: 3.139, lng: 101.687, signal: true, ai_control: "ai", soft_demo: true },
  { device_id: "plant-b-12", id: "plant-b-12", label: "Plant B · Zone 12", display_label: "Plant B · Zone 12", lat: 3.141, lng: 101.691, signal: true, ai_control: "human", soft_demo: true },
  { device_id: "dock-east-02", id: "dock-east-02", label: "East Dock · Pad 02", display_label: "East Dock · Pad 02", lat: 3.137, lng: 101.694, signal: true, ai_control: "human", soft_demo: true },
  { device_id: "lobby-main", id: "lobby-main", label: "Main Lobby", display_label: "Main Lobby", lat: 3.140, lng: 101.686, signal: true, ai_control: "ai", soft_demo: true },
  { device_id: "yard-west", id: "yard-west", label: "West Yard · Fence 7", display_label: "West Yard · Fence 7", lat: 3.136, lng: 101.682, signal: true, ai_control: "none", soft_demo: true },
  { device_id: "stair-c", id: "stair-c", label: "Stairwell C", display_label: "Stairwell C", lat: 3.138, lng: 101.688, signal: false, ai_control: "none", soft_demo: true },
  { device_id: "roof-cam-a", id: "roof-cam-a", label: "Roof · CAM-A", display_label: "Roof · CAM-A", lat: 3.1395, lng: 101.689, signal: true, ai_control: "ai", soft_demo: true },
  { device_id: "parking-3", id: "parking-3", label: "Parking · Bay 3", display_label: "Parking · Bay 3", lat: 3.1355, lng: 101.685, signal: false, ai_control: "none", soft_demo: true },
  { device_id: "loading-9", id: "loading-9", label: "Loading · Bay 9", display_label: "Loading · Bay 9", lat: 3.1375, lng: 101.692, signal: true, ai_control: "none", soft_demo: true },
  { device_id: "fence-south-2", id: "fence-south-2", label: "South Fence · 2", display_label: "South Fence · 2", lat: 3.1348, lng: 101.6885, signal: true, ai_control: "ai", soft_demo: true },
  { device_id: "hydrant-west", id: "hydrant-west", label: "West Hydrant", display_label: "West Hydrant", lat: 3.1405, lng: 101.6905, signal: false, ai_control: "none", soft_demo: true },
  { device_id: "drone-pad-1", id: "drone-pad-1", label: "Drone Pad · 1", display_label: "Drone Pad · 1", lat: 3.1415, lng: 101.6865, signal: true, ai_control: "ai", soft_demo: true },
];

/**
 * Soft rank rows keyed by device_id — Assign step 2.
 * kind: human | drone | robot (Soft practice mixed fleet; Soft invent Live machine write forbidden).
 */
export const SOFT_RANK_BY_DEVICE = {
  "gate-north-04": [
    { id: "chen.wei", label: "Chen Wei · UNIT-7", kind: "human", rank: 1, km: 0.4, eligible: true, on: true, busy: false, stale: false, reason: "nearest Soft", soft_demo: true },
    { id: "drone.scout-a", label: "Scout-A · UAV", kind: "drone", rank: 2, km: 0.7, eligible: true, on: true, busy: false, stale: false, reason: "air Soft", soft_demo: true },
    { id: "aisha.rahman", label: "Aisha Rahman · UNIT-1", kind: "human", rank: 3, km: 0.9, eligible: true, on: true, busy: false, stale: false, reason: "ranked Soft", soft_demo: true },
    { id: "robot.patrol-2", label: "Patrol-2 · UGV", kind: "robot", rank: 4, km: 1.1, eligible: true, on: true, busy: false, stale: false, reason: "ground Soft", soft_demo: true },
    { id: "luis.park", label: "Luis Park", kind: "human", rank: 5, km: 1.4, eligible: false, on: false, busy: false, stale: false, reason: "off call", soft_demo: true },
  ],
  "plant-b-12": [
    { id: "maya.ortiz", label: "Maya Ortiz · UNIT-3", kind: "human", rank: 1, km: 0.6, eligible: true, on: true, busy: false, stale: false, reason: "nearest Soft", soft_demo: true },
    { id: "drone.thermal-1", label: "Thermal-1 · UAV", kind: "drone", rank: 2, km: 1.0, eligible: true, on: true, busy: false, stale: false, reason: "heat Soft", soft_demo: true },
    { id: "omar.hassan", label: "Omar Hassan · UNIT-12", kind: "human", rank: 3, km: 1.8, eligible: true, on: true, busy: false, stale: false, reason: "ranked Soft", soft_demo: true },
  ],
  "dock-east-02": [
    { id: "omar.hassan", label: "Omar Hassan · UNIT-12", kind: "human", rank: 1, km: 0.5, eligible: true, on: true, busy: false, stale: false, reason: "nearest Soft", soft_demo: true },
    { id: "robot.pad-guard", label: "Pad-Guard · UGV", kind: "robot", rank: 2, km: 0.8, eligible: true, on: true, busy: false, stale: false, reason: "pad Soft", soft_demo: true },
    { id: "chen.wei", label: "Chen Wei · UNIT-7", kind: "human", rank: 3, km: 2.1, eligible: true, on: true, busy: false, stale: false, reason: "ranked Soft", soft_demo: true },
  ],
  "lobby-main": [
    { id: "aisha.rahman", label: "Aisha Rahman · UNIT-1", kind: "human", rank: 1, km: 0.1, eligible: true, on: true, busy: false, stale: false, reason: "on scene Soft", soft_demo: true },
    { id: "drone.lobby-eye", label: "Lobby-Eye · UAV", kind: "drone", rank: 2, km: 0.2, eligible: true, on: true, busy: false, stale: false, reason: "overhead Soft", soft_demo: true },
  ],
  "yard-west": [
    { id: "nina.cho", label: "Nina Cho", kind: "human", rank: 1, km: 0.8, eligible: false, on: false, busy: false, stale: true, reason: "no consent", soft_demo: true },
    { id: "robot.fence-7", label: "Fence-7 · UGV", kind: "robot", rank: 2, km: 1.2, eligible: true, on: true, busy: false, stale: false, reason: "fence Soft", soft_demo: true },
    { id: "chen.wei", label: "Chen Wei · UNIT-7", kind: "human", rank: 3, km: 3.4, eligible: true, on: true, busy: false, stale: false, reason: "far Soft", soft_demo: true },
  ],
  "stair-c": [
    { id: "luis.park", label: "Luis Park", kind: "human", rank: 1, km: 0.3, eligible: false, on: false, busy: false, stale: false, reason: "off call", soft_demo: true },
  ],
};

/** Soft Queue / Command River rows — share incident ids with Cases. */
export const SOFT_QUEUE_SEED = [
  {
    id: "soft-demo-p1-gate",
    status: "pending",
    who: "Chen Wei",
    callsign: "UNIT-7",
    channel: "CH-OPS-1",
    zone: "North Gate",
    dev: "gate-north-04",
    devLabel: "North Gate · CAM-04",
    reason: "Perimeter cut · thermal + PIR stack",
    aiNote: "Recommend dual response · seal pedestrian lane",
    risk: 92,
    etaMin: 4,
    ageSec: 187,
    km: "0.4",
    opened: "—",
    correlation: "ALM-9F2C",
    incident: "soft-inc-p1-gate",
    resolution: "",
    soft: true,
    soft_demo: true,
  },
  {
    id: "soft-demo-p2-plant",
    status: "accepted",
    who: "Maya Ortiz",
    callsign: "UNIT-3",
    channel: "CH-FIRE",
    zone: "Plant B",
    dev: "plant-b-12",
    devLabel: "Plant B · Zone 12",
    reason: "Heat plume rising · stack sensor trip",
    aiNote: "Accepted · staging at west hydrant",
    risk: 74,
    etaMin: 9,
    ageSec: 412,
    km: "1.2",
    opened: "—",
    correlation: "ALM-441A",
    incident: "soft-inc-p2-plant",
    resolution: "",
    soft: true,
    soft_demo: true,
  },
  {
    id: "soft-demo-p2-dock",
    status: "en_route",
    who: "Omar Hassan",
    callsign: "UNIT-12",
    channel: "CH-OPS-2",
    zone: "East Dock",
    dev: "dock-east-02",
    devLabel: "East Dock · Pad 02",
    reason: "Plate mismatch · vehicle holding pad",
    aiNote: "En route · ETA inside gate window",
    risk: 68,
    etaMin: 6,
    ageSec: 540,
    km: "2.1",
    opened: "—",
    correlation: "ALM-77BE",
    incident: "soft-inc-p2-dock",
    resolution: "",
    soft: true,
    soft_demo: true,
  },
  {
    id: "soft-demo-p3-lobby",
    status: "on_scene",
    who: "Aisha Rahman",
    callsign: "UNIT-1",
    channel: "CH-OPS-1",
    zone: "Main Lobby",
    dev: "lobby-main",
    devLabel: "Main Lobby",
    reason: "Panic latch · human confirm pending",
    aiNote: "On scene · hold elevators · wait proof",
    risk: 48,
    etaMin: 0,
    ageSec: 910,
    km: "0.1",
    opened: "—",
    correlation: "ALM-C01D",
    incident: "soft-inc-p3-lobby",
    resolution: "",
    soft: true,
    soft_demo: true,
  },
  {
    id: "soft-demo-p4-yard",
    status: "pending",
    who: "—",
    callsign: "UNASSIGNED",
    channel: "CH-WATCH",
    zone: "West Yard",
    dev: "yard-west",
    devLabel: "West Yard · Fence 7",
    reason: "Low motion · no visual confirm",
    aiNote: "Queue only · no auto-advance",
    risk: 22,
    etaMin: null,
    ageSec: 1205,
    km: "3.4",
    opened: "—",
    correlation: "ALM-0E11",
    incident: "soft-inc-p4-yard",
    resolution: "",
    soft: true,
    soft_demo: true,
  },
  {
    id: "soft-demo-resolved",
    status: "resolved",
    who: "Luis Park",
    callsign: "UNIT-5",
    channel: "CH-OPS-2",
    zone: "Stair C",
    dev: "stair-c",
    devLabel: "Stairwell C",
    reason: "False alarm · contractor badge",
    aiNote: "Closed · proof attached Soft only",
    risk: 12,
    etaMin: 0,
    ageSec: 2400,
    km: "0.8",
    opened: "—",
    correlation: "ALM-22F0",
    incident: "soft-inc-resolved",
    resolution: "false_alarm",
    soft: true,
    soft_demo: true,
  },
];

/** Soft Cases catalog — incident ids match Queue.incident. */
export const SOFT_CASE_SEED = [
  { incident_id: "soft-inc-p1-gate", id: "soft-inc-p1-gate", device_id: "gate-north-04", status: "open", state: "open", event_type: "alarm.trigger", zone: "North Gate", soft_demo: true },
  { incident_id: "soft-inc-p2-plant", id: "soft-inc-p2-plant", device_id: "plant-b-12", status: "open", state: "accepted", event_type: "alarm.trigger", zone: "Plant B", soft_demo: true },
  { incident_id: "soft-inc-p2-dock", id: "soft-inc-p2-dock", device_id: "dock-east-02", status: "open", state: "en_route", event_type: "alarm.trigger", zone: "East Dock", soft_demo: true },
  { incident_id: "soft-inc-p3-lobby", id: "soft-inc-p3-lobby", device_id: "lobby-main", status: "open", state: "on_scene", event_type: "panic.latch", zone: "Main Lobby", soft_demo: true },
  { incident_id: "soft-inc-p4-yard", id: "soft-inc-p4-yard", device_id: "yard-west", status: "open", state: "pending", event_type: "motion.low", zone: "West Yard", soft_demo: true },
  { incident_id: "soft-inc-resolved", id: "soft-inc-resolved", device_id: "stair-c", status: "closed", state: "resolved", event_type: "alarm.trigger", zone: "Stair C", soft_demo: true },
];

export function softIncidentId(id) {
  return String(id || "").trim().startsWith("soft-inc-");
}

export function softQueueClone() {
  return SOFT_QUEUE_SEED.map((r) => ({ ...r }));
}

export function softCaseClone() {
  return SOFT_CASE_SEED.map((r) => ({ ...r }));
}

export function softPeopleClone() {
  return SOFT_PEOPLE.map((r) => ({ ...r }));
}

export function softDevicesClone() {
  return SOFT_DEVICES.map((r) => ({ ...r }));
}

/** Pure: Soft drop-target marks — signal lamp + AI/human control. */
export function softDeviceMarksOf(device) {
  const d = device && typeof device === "object" ? device : {};
  const signal = d.signal === true || d.has_signal === true;
  const raw = String(d.ai_control || d.control || "none").toLowerCase();
  const aiControl = raw === "ai" || raw === "human" ? raw : "none";
  return { signal, aiControl };
}

export function softRankForDevice(deviceId) {
  const rows = SOFT_RANK_BY_DEVICE[String(deviceId || "").trim()] || [];
  return rows.map((r) => ({ ...r }));
}

/** Operator-facing Soft sync honesty — localhost Soft practice only. */
export const SOFT_SYNC_HONESTY =
  "Soft practice stays on Response. Soft Queue · People · Assign stamp the same Soft task live. Map Soft focuses the linked device · Soft≠Live. Cameras Soft do not invent Live here.";

/** Production Live honesty — never invite Soft practice on a Live desk.
 * Honesty: Live Response · Soft practice is local-only · Soft≠Live
 */
export const LIVE_SYNC_HONESTY =
  "This is the live site. Practice stays on this computer only. Queue, people, and assign read the same site.";
